import axios from 'axios';
import { push } from 'react-router-redux';

// Constants.
import * as ConfigConstants from 'constants/ConfigConstants';
import * as ErrorConstants from 'constants/ErrorConstants';
import {goToLogin} from "./AuthActions";

function requestLoadConfig() {
  return {
    type: ConfigConstants.LOAD_CONFIG_REQUEST,
  };
}

function receiveLoadConfig(config) {
  return {
    type: ConfigConstants.LOAD_CONFIG_SUCCESS,
    config,
  };
}

function receiveLoadConfigError(response) {
  return {
    type: ErrorConstants.LOAD_REQUEST_FAILURE,
    response,
  };
}

export function loadConfig() {
  return dispatch => {
    dispatch(requestLoadConfig());
    axios({
      method: 'GET',
      url: '/dashboard_api/v1/config/env/',
    })
      .then((response) => {
        const config = response.data;
        dispatch(receiveLoadConfig(config));
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            dispatch(goToLogin());
          }
          else {
            dispatch(receiveLoadConfigError(error.response));
            // dispatch(push({ pathname: '/error' }));
          }
        }
      });
  };
}
